"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateStringFromTimestamp = exports.getCurrentYearAndMonth = exports.getMonthDetails = exports.getDayDetails = exports.isSelectedDay = exports.isCurrentDay = exports.monthsMap = exports.daysMap = exports.todayTimestamp = void 0;
const oneDay = 60 * 60 * 24 * 1000;
const todayTimestamp = Date.now() - Date.now() % oneDay + new Date().getTimezoneOffset() * 1000 * 60;
exports.todayTimestamp = todayTimestamp;
const daysMap = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
exports.daysMap = daysMap;
const monthsMap = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
exports.monthsMap = monthsMap;

const isCurrentDay = day => day.timestamp === todayTimestamp;

exports.isCurrentDay = isCurrentDay;

const isSelectedDay = (day, selectedDay) => day.timestamp === selectedDay;

exports.isSelectedDay = isSelectedDay;

const getDayDetails = args => {
  let date = args.index - args.firstDay;
  let day = args.index % 7;
  let prevMonth = args.month - 1;
  let prevYear = args.year;

  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear--;
  }

  let prevMonthNumberOfDays = 40 - new Date(prevYear, prevMonth, 40).getDate();

  let _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;

  let month = date < 0 ? -1 : date >= args.numberOfDays ? 1 : 0;
  let timestamp = new Date(args.year, args.month, _date).getTime();
  return {
    date: _date,
    day,
    month,
    timestamp,
    dayString: daysMap[day]
  };
};

exports.getDayDetails = getDayDetails;

const getMonthDetails = (year, month) => {
  let firstDay = new Date(year, month).getDay();
  let numberOfDays = 40 - new Date(year, month, 40).getDate();
  let monthArray = [];
  let rows = 6;
  let currentDay = null;
  let index = 0;
  let cols = 7;

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      currentDay = getDayDetails({
        index,
        numberOfDays,
        firstDay,
        year,
        month
      });
      monthArray.push(currentDay);
      index++;
    }
  }

  return monthArray;
};

exports.getMonthDetails = getMonthDetails;

const getCurrentYearAndMonth = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  return {
    year,
    month
  };
};

exports.getCurrentYearAndMonth = getCurrentYearAndMonth;

const getDateStringFromTimestamp = timestamp => {
  const dateObj = new Date(timestamp);
  const month = dateObj.getMonth() + 1;
  const date = dateObj.getDate();
  return `${dateObj.getFullYear()}-${month < 10 ? "0" + month : month}-${date < 10 ? "0" + date : date}`;
};

exports.getDateStringFromTimestamp = getDateStringFromTimestamp;